import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MapNoteHeader from './MapNoteHeader.jsx';
import MapNoteStatusButton from './MapNoteStatusButton.jsx';
import MapNoteType from './MapNoteType.jsx';
import MapNoteComments from './MapNoteComments.jsx';
import MapNotePostComment from './MapNotePostComment.jsx';

import Spinner from '../spinner/Spinner.jsx';

import s from './MapNoteSheet.module.scss';

const MapNoteSheet = props => {
    const { mapNote, userEmail, onStatusChange, onTrash, onEdit, onClose, comment, onCommentChange, onCommentUpload, onCommentDelete, onImageUpload, loading } = props;
    const hasType = mapNote.noteType !== 'noType';
    return (
        <div className={s.mapNoteSheetContainer}>
            <div className={s.mapNoteSheet}>
                <MapNoteHeader userEmail={userEmail} mapNote={mapNote} onTrash={onTrash} onEdit={onEdit} onClose={onClose} />
                <MapNoteStatusButton status={mapNote.noteStatus} onStatusChange={onStatusChange} />
                <div className={s.subject}>{mapNote.subject}</div>
                {hasType && <MapNoteType noteType={mapNote.noteType} />}
                <div className={s.divider} />
                <MapNoteComments userEmail={userEmail} mapNote={mapNote} onCommentDelete={onCommentDelete} />
            </div>
            <MapNotePostComment comment={comment} onCommentChange={onCommentChange} onCommentUpload={onCommentUpload} onImageUpload={onImageUpload} />
            <div className={classNames({ [s.loading]: loading })}>
                <Spinner loading={loading} />
            </div>
        </div>
    );
};

MapNoteSheet.propTypes = {
    loading: PropTypes.bool,
    comment: PropTypes.string.isRequired,
    userEmail: PropTypes.string.isRequired,
    mapNote: PropTypes.object.isRequired,
    onCommentChange: PropTypes.func.isRequired,
    onCommentUpload: PropTypes.func.isRequired,
    onImageUpload: PropTypes.func.isRequired,
    onCommentDelete: PropTypes.func.isRequired,
    onStatusChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onTrash: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
};

MapNoteSheet.defaultProps = { loading: false };

export default MapNoteSheet;
